import { cartAdjustments, cartItems } from '../data/program';
import type { CartLine } from '../types/volunteer';

export interface Cart {
  items: CartLine[];
  adjustments: CartLine[];
  volunteer: CartLine | null;
  subtotal: number;
  total: number;
}

export function buildCart(amount: number, discountApplied: boolean): Cart {
  const subtotal = cartItems.reduce((s, l) => s + l.amount, 0);
  const adjustmentTotal = cartAdjustments.reduce((s, l) => s + l.amount, 0);
  const volunteer: CartLine | null = discountApplied
    ? { id: 'vrd', label: 'Volunteer Registration Discount', amount: -amount, kind: 'volunteer' }
    : null;
  const total = Math.max(0, subtotal + adjustmentTotal + (volunteer ? volunteer.amount : 0));
  return { items: cartItems, adjustments: cartAdjustments, volunteer, subtotal, total };
}
